import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { SearchAutocomplete } from "@/components/SearchAutocomplete";

/**
 * Buscador de reparaciones reutilizable (nº reparación / serial / cliente…).
 *
 * Único componente + backend compartido para "Mis reparaciones" y la ficha de
 * Reparación. La normalización y la prioridad (código exacto → serial → tokens)
 * viven en el endpoint `GET /repairs/search/{q}`, respetando los permisos del CRM.
 * Al seleccionar un resultado se abre su ficha.
 */
export function RepairSearchAutocomplete({
  className = "w-full sm:w-80",
  testid = "repair-search-autocomplete",
  onSelect,
}) {
  const navigate = useNavigate();
  const fetchRepairs = useCallback(async (q) => {
    const r = await api.get(`/repairs/search/${encodeURIComponent(q)}`);
    return Array.isArray(r.data) ? r.data : [];
  }, []);

  return (
    <SearchAutocomplete
      testid={testid}
      className={className}
      placeholder="Buscar por nº reparación o nº de serie…"
      fetcher={fetchRepairs}
      getKey={(o) => o.id}
      onSelect={(o) => { if (onSelect) onSelect(o); navigate(`/repairs/${o.id}`); }}
      renderItem={(o) => {
        const device = [o.device_type, o.brand, o.model].filter(Boolean).join(" ");
        const rest = [device, o.serial, o.customer_name].filter(Boolean).join(" · ");
        return (
          <div className="flex items-center gap-1.5 truncate">
            <span className="font-mono text-[11px] font-bold text-[#3F5222] shrink-0">{o.code}</span>
            {rest && <span className="text-[#C8CABF] shrink-0">·</span>}
            <span className="truncate text-[#2B2B28]">{rest || "—"}</span>
          </div>
        );
      }}
    />
  );
}

export default RepairSearchAutocomplete;
